import { render, staticRenderFns } from "./CashiersAddNew.vue?vue&type=template&id=338fe5ce"
import script from "./CashiersAddNew.vue?vue&type=script&lang=js"
export * from "./CashiersAddNew.vue?vue&type=script&lang=js"
import style0 from "./CashiersAddNew.vue?vue&type=style&index=0&id=338fe5ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports